import Echo from "laravel-echo"
import GeneralSocket from "@/ws/General.socket.js";
import store from "@/store";

export const ConnectSocket = () => {

    window.Pusher = require('pusher-js');

    const socket = new Echo({
        broadcaster: 'pusher',
        key: process.env.VUE_APP_WEBSOCKETS_KEY,
        wsHost: process.env.VUE_APP_WEBSOCKETS_SERVER,
        wsPort: process.env.VUE_APP_WEBSOCKETS_PORT,
        wssPort: process.env.VUE_APP_WEBSOCKETS_PORT,
        cluster: process.env.VUE_APP_WEBSOCKETS_CLUSTER,
        forceTLS: false,
        disableStats: false,
        enabledTransports: ["ws", "wss"],
        // authEndpoint: 'http://127.0.0.1:8000/api/broadcasting/auth',
        // auth: {
        //     headers: {
        //         Authorization: 'Bearer ' + localStorage.getItem('token'),
        //     }
        // },

    })

    window.Echo = socket;

    if (socket == null || socket == undefined) {
        return;
    }

    GeneralSocket(window.Echo);
}

export const DisconectSocket = () => {
    // window.Echo
}

const storeUser = store.getters["auth/currentUser"];
if (storeUser != null) {
    ConnectSocket();
}